import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./award.css";
import { fetchVisitordata } from "../../Redux/Slice"; // Adjust the path as necessary
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';
const Awards = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isVisitor_Record = useSelector((state) => state.cms.isVisitor_Record);
  const [barcodeValue, setBarcodeValue] = useState("");
  const [searchSuccess, setSearchSuccess] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(fetchVisitordata(barcodeValue));
    setBarcodeValue("");
  };
  const location = useLocation();

  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);
  useEffect(() => {
    console.log("Visitor Record:", isVisitor_Record); // Debug log

    if (isVisitor_Record.length > 0) {
      const record = isVisitor_Record[0];
      if (record?.form_data && record?.form_data.membership_no) {
        setSearchSuccess(true);
        toast.success("Success: Data found!");
      } else {
        setSearchSuccess(false);
        toast.error("Error: Record not found.");
      }
    } else if (isVisitor_Record.length === 0) {
      setSearchSuccess(false);
      toast.error("Error: Record not found.");
    }
  }, [isVisitor_Record]); // Update toast and success state based on isVisitor_Record

  useEffect(() => {
    const record = isVisitor_Record[0];
    if (record?.form_data && record?.form_data.membership_no) {
      const { org_id, exb_id, form_id ,_id } = isVisitor_Record[0]; // Adjust the path as necessary
      const targetUrl = `https://admin.expoplan.in/visitor-form?org_id=668d11d87d72eb70ec482b18&exb_id=668d12e57d72eb70ec482c69&form_id=66925902c6589ad8b40a6fe7&visitor_id=${_id}`;

      // Open the target URL in a new tab/window using window.open with proper attributes
      const newWindow = window.open(targetUrl, "_blank", "noopener,noreferrer");
      if (newWindow) {
        newWindow.focus(); // Focus the newly opened window
      }
    }
  }, [searchSuccess, isVisitor_Record]); // Navigate to visitor form on success

  const handleInputChange = (event) => {
    setBarcodeValue(event.target.value);
  };
  return (
    <div className="page-wrapper">
      <section
        className="page-title"
        style={{
          backgroundImage:
            "url(https://www.fhraiconvention.com/cdn/images/background/02.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>Awards of Excellence</h1>
          <ul className="bread-crumb clearfix">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>Awards of Excellence</li>
          </ul>
        </div>
      </section>

      <section className="contact-page-section">
        <div className="auto-container">
          <div className="form-column col-lg-8 col-md-12 col-sm-12 shadow-box">
            <h2>To Apply for Award,Enter your Registration No.</h2>
            <form className="barcode-search-form" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Enter registration number"
                name="barcode"
                className="barcode-input"
                value={barcodeValue} // Bind input value to state
                onChange={handleInputChange}
              />
              <button type="submit" className="search-button">
                Search
              </button>
            </form>
          </div>
        </div>
      </section>

      <ToastContainer />
    </div>
  );
};

export default Awards;
